export const TERMS_HTML = `<h3>Términos y Condiciones de Uso</h3>
<p><strong>Última actualización:</strong> Junio 2025</p>

<h4>1. Aceptación de los Términos</h4>
<p>Al registrarte y utilizar la plataforma Domus Secura (en adelante, "la Plataforma"), aceptas los presentes Términos y Condiciones y la Política de Privacidad. Si no estás de acuerdo, no debes utilizar el servicio.</p>

<h4>2. Descripción del Servicio</h4>
<p>Domus Secura es una plataforma de seguridad residencial que proporciona:</p>
<ul>
  <li><strong>Botón de pánico:</strong> alerta en tiempo real con geolocalización a contactos de emergencia vía WhatsApp, llamada y notificación push.</li>
  <li><strong>Gestión de grupos:</strong> administración de usuarios, contactos de emergencia y permisos dentro de una comunidad o condominio.</li>
  <li><strong>Panel de administración:</strong> historial de alertas, configuración de notificaciones y monitoreo en tiempo real.</li>
  <li><strong>Control IoT:</strong> integración con dispositivos ESP32 para apertura de portones, activación de sirenas y sensores.</li>
</ul>

<h4>3. Registro y Cuenta</h4>
<p>Para utilizar la Plataforma, debes registrarte proporcionando información veraz y completa. Eres responsable de mantener la confidencialidad de tus credenciales de acceso y de todas las actividades que ocurran bajo tu cuenta. Debes notificar inmediatamente cualquier uso no autorizado de tu cuenta.</p>

<h4>4. Privacidad y Datos Personales</h4>
<p>El tratamiento de tus datos personales se rige por nuestra Política de Privacidad, que forma parte integral de estos Términos. Al aceptar estos Términos, también aceptas nuestra Política de Privacidad.</p>

<h4>5. Uso Aceptable</h4>
<p>Te comprometes a utilizar la Plataforma de manera responsable y ética. Queda prohibido:</p>
<ul>
  <li>Generar alertas falsas o maliciosas.</li>
  <li>Intentar acceder a cuentas de otros usuarios sin autorización.</li>
  <li>Utilizar la Plataforma para fines ilegales o no autorizados.</li>
  <li>Interferir con el funcionamiento de la Plataforma o sus sistemas.</li>
  <li>Realizar ingeniería inversa, descompilar o modificar el software de la Plataforma.</li>
</ul>

<h4>6. Alertas de Emergencia</h4>
<p>El botón de pánico es una herramienta de seguridad crítica. Al usarlo aceptas que:</p>
<ul>
  <li>La activación de una alerta implica la notificación automática a tus contactos de emergencia configurados.</li>
  <li>La geolocalización se comparte con tus contactos de emergencia al activar una alerta.</li>
  <li>El uso del botón de pánico para generar alertas falsas constituye una falta grave y puede resultar en la suspensión inmediata de tu cuenta.</li>
  <li>El abuso reiterado del sistema de alertas dará lugar a la cancelación permanente del servicio.</li>
</ul>

<h4>7. Planes y Suscripciones</h4>
<p>La Plataforma ofrece planes gratuitos y de pago. Las características y precios de cada plan se especifican en la sección de suscripción. Los pagos se procesan a través de proveedores externos y están sujetos a sus términos y condiciones. El impago de un plan de pago puede resultar en la degradación del servicio al plan gratuito.</p>

<h4>8. Cancelación y Suspensión</h4>
<p>Podemos suspender o cancelar tu cuenta si:</p>
<ul>
  <li>Violas estos Términos y Condiciones.</li>
  <li>Incumples obligaciones de pago (en planes pagos).</li>
  <li>Generas alertas falsas de forma reiterada.</li>
  <li>Tu conducta representa un riesgo para la Plataforma u otros usuarios.</li>
</ul>
<p>Puedes cancelar tu cuenta en cualquier momento desde la sección de perfil. Al cancelar, tus datos se eliminarán según lo establecido en la Política de Privacidad.</p>

<h4>9. Limitación de Responsabilidad</h4>
<p>La Plataforma se proporciona "tal cual", sin garantías de disponibilidad continua o funcionamiento sin interrupciones. No somos responsables por:</p>
<ul>
  <li>Daños derivados del uso o la imposibilidad de usar el servicio.</li>
  <li>Retrasos o fallos en la entrega de notificaciones debido a problemas de red de terceros (WhatsApp, telefonía, internet).</li>
  <li>Actuaciones de los contactos de emergencia o miembros del grupo.</li>
  <li>Pérdida de datos por causas ajenas a nuestra voluntad.</li>
</ul>

<h4>10. Propiedad Intelectual</h4>
<p>Todos los derechos de propiedad intelectual sobre la Plataforma, incluyendo su código, diseño, marcas y contenidos, pertenecen a Domus Secura o sus licenciantes. No se otorga ningún derecho de uso sobre estos elementos más allá de lo necesario para utilizar el servicio.</p>

<h4>11. Modificaciones</h4>
<p>Nos reservamos el derecho de modificar estos Términos en cualquier momento. Las modificaciones entrarán en vigor 30 días después de su notificación a los usuarios. El uso continuado de la Plataforma después de ese período constituye la aceptación de los nuevos términos.</p>

<h4>12. Legislación Aplicable</h4>
<p>Estos Términos se rigen por las leyes de la República de Chile. Cualquier controversia se someterá a los tribunales de Santiago de Chile.</p>

<h4>13. Contacto</h4>
<p>Para consultas sobre estos Términos, contáctanos en: <strong>contacto@domus-secura.cl</strong></p>`

export const PRIVACY_HTML = `<h3>Política de Privacidad y Protección de Datos</h3>
<p><strong>Última actualización:</strong> Junio 2025</p>

<h4>1. Identificación del Responsable</h4>
<p>Domus Secura (en adelante, "el Responsable") es responsable del tratamiento de los datos personales recopilados a través de la Plataforma. Para ejercer tus derechos, contacta a: <strong>contacto@domus-secura.cl</strong></p>

<h4>2. Marco Legal</h4>
<p>Esta Política de Privacidad se rige por:</p>
<ul>
  <li><strong>Ley N° 19.628</strong> sobre Protección de la Vida Privada de Chile.</li>
  <li><strong>Ley N° 21.719</strong> que crea la Agencia de Protección de Datos Personales y modifica la Ley N° 19.628.</li>
  <li><strong>Reglamento General de Protección de Datos (GDPR)</strong> de la Unión Europea, en lo aplicable a usuarios residentes en la UE.</li>
</ul>

<h4>3. Datos Personales que Recopilamos</h4>
<p><strong>Datos proporcionados por el usuario:</strong></p>
<ul>
  <li>Nombre y apellidos.</li>
  <li>Correo electrónico.</li>
  <li>Número de teléfono/WhatsApp.</li>
  <li>Contraseña (almacenada con hash bcrypt).</li>
  <li>Dirección y grupo/comunidad al que pertenece.</li>
</ul>
<p><strong>Datos generados durante el uso:</strong></p>
<ul>
  <li>Ubicación geográfica (solo al activar alertas o usar funciones de geolocalización).</li>
  <li>Historial de alertas (fecha, hora, tipo, ubicación).</li>
  <li>Registros de acceso y actividad en la Plataforma.</li>
  <li>Configuración de dispositivos IoT asociados.</li>
</ul>
<p><strong>Datos de terceros proporcionados por el usuario:</strong></p>
<ul>
  <li>Nombres y números de teléfono de contactos de emergencia.</li>
  <li>Datos de miembros del grupo (nombres, teléfonos, correos).</li>
</ul>

<h4>4. Finalidades del Tratamiento</h4>
<p>Tus datos personales se tratan para las siguientes finalidades:</p>
<ul>
  <li><strong>Gestión de alertas:</strong> procesar y transmitir alertas de emergencia a tus contactos configurados.</li>
  <li><strong>Notificaciones:</strong> enviar alertas vía WhatsApp, llamadas automáticas y notificaciones push.</li>
  <li><strong>Geolocalización:</strong> determinar la ubicación exacta de una alerta para una respuesta efectiva.</li>
  <li><strong>Control IoT:</strong> permitir la apertura remota de portones y activación de sirenas.</li>
  <li><strong>Administración:</strong> gestionar tu cuenta, grupo y suscripción.</li>
  <li><strong>Seguridad:</strong> detectar y prevenir uso fraudulento o abusivo del sistema.</li>
  <li><strong>Mejora del servicio:</strong> analizar patrones de uso para optimizar la Plataforma.</li>
</ul>

<h4>5. Base Legal del Tratamiento</h4>
<p>El tratamiento de tus datos se basa en:</p>
<ul>
  <li><strong>Consentimiento explícito:</strong> al registrarte y aceptar esta política.</li>
  <li><strong>Ejecución del servicio:</strong> el tratamiento es necesario para proporcionar las funcionalidades solicitadas.</li>
  <li><strong>Interés legítimo:</strong> seguridad de la Plataforma, prevención de fraudes y mejora del servicio.</li>
  <li><strong>Cumplimiento legal:</strong> obligaciones derivadas de la legislación chilena aplicable.</li>
</ul>

<h4>6. Destinatarios de los Datos</h4>
<p>Tus datos pueden ser compartidos con:</p>
<ul>
  <li><strong>Tus contactos de emergencia:</strong> reciben tu nombre, ubicación y tipo de alerta cuando activas el botón de pánico.</li>
  <li><strong>Miembros de tu grupo:</strong> ven tu nombre y estado de alerta en el panel comunitario.</li>
  <li><strong>Proveedores de servicios:</strong>
    <ul>
      <li><strong>Cloudflare (D1, Workers, R2):</strong> infraestructura de hosting y almacenamiento de datos.</li>
      <li><strong>Evolution API:</strong> envío de mensajes WhatsApp y llamadas automáticas.</li>
      <li><strong>Google (Fonts, Maps):</strong> recursos de interfaz y visualización de mapas.</li>
    </ul>
  </li>
  <li><strong>Autoridades competentes:</strong> cuando lo exija la ley o medie una orden judicial.</li>
</ul>
<p>No vendemos tus datos personales a terceros bajo ninguna circunstancia.</p>

<h4>7. Transferencias Internacionales</h4>
<p>Tus datos pueden ser transferidos y almacenados en servidores ubicados fuera de Chile, incluyendo Estados Unidos y la Unión Europea (Cloudflare opera una red global). Estas transferencias se realizan con garantías adecuadas mediante cláusulas contractuales tipo y certificaciones internacionales (ISO 27001, SOC 2) de nuestros proveedores.</p>

<h4>8. Período de Retención</h4>
<p>Conservamos tus datos personales durante el tiempo necesario para cumplir las finalidades descritas:</p>
<ul>
  <li><strong>Datos de cuenta:</strong> mientras mantengas tu cuenta activa.</li>
  <li><strong>Historial de alertas:</strong> hasta 12 meses desde la última alerta.</li>
  <li><strong>Registros de actividad:</strong> hasta 6 meses.</li>
  <li><strong>Datos de contactos de emergencia:</strong> mientras estén configurados en tu cuenta.</li>
</ul>
<p>Al eliminar tu cuenta, todos los datos asociados se eliminan en un plazo máximo de 30 días, excepto aquellos que debamos conservar por obligaciones legales.</p>

<h4>9. Tus Derechos</h4>
<p>Puedes ejercer los siguientes derechos en cualquier momento contactando a <strong>contacto@domus-secura.cl</strong> o desde la sección de perfil en la Plataforma:</p>
<ul>
  <li><strong>Acceso:</strong> solicitar una copia de todos tus datos personales almacenados.</li>
  <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos.</li>
  <li><strong>Cancelación (Derecho al olvido):</strong> eliminar tu cuenta y todos tus datos asociados.</li>
  <li><strong>Oposición:</strong> oponerte al tratamiento de tus datos para fines específicos.</li>
  <li><strong>Portabilidad:</strong> solicitar tus datos en un formato estructurado y de uso común.</li>
  <li><strong>Limitación:</strong> restringir el tratamiento de tus datos en determinadas circunstancias.</li>
  <li><strong>Retirar el consentimiento:</strong> en cualquier momento, sin afectar la licitud del tratamiento previo.</li>
</ul>
<p>Responderemos a tu solicitud en un plazo máximo de 10 días hábiles. Si no quedas satisfecho, puedes presentar un reclamo ante la Agencia de Protección de Datos Personales de Chile.</p>

<h4>10. Medidas de Seguridad</h4>
<p>Implementamos medidas técnicas y organizativas para proteger tus datos:</p>
<ul>
  <li>Cifrado en tránsito (TLS 1.3) para todas las comunicaciones.</li>
  <li>Cifrado de contraseñas mediante bcrypt (10 rondas de sal).</li>
  <li>Tokens JWT firmados para autenticación.</li>
  <li>Rate limiting para prevenir ataques de fuerza bruta.</li>
  <li>Infraestructura Cloudflare con protección DDoS y WAF.</li>
  <li>Acceso restringido a bases de datos mediante autenticación de API.</li>
  <li> Auditorías periódicas de seguridad y cumplimiento.</li>
</ul>

<h4>11. Datos de Menores</h4>
<p>El servicio no está dirigido a menores de 18 años. No recopilamos intencionadamente datos de menores. Si tienes conocimiento de que un menor nos ha proporcionado datos personales sin consentimiento parental, contáctanos para eliminarlos.</p>

<h4>12. Cookies y Tecnologías Similares</h4>
<p>La Plataforma utiliza almacenamiento local del navegador (localStorage) para mantener la sesión iniciada y cookies estrictamente necesarias para el funcionamiento de la autenticación. No utilizamos cookies de seguimiento, publicidad ni análisis de terceros.</p>

<h4>13. Cambios en la Política de Privacidad</h4>
<p>Esta política puede actualizarse para reflejar cambios en nuestras prácticas o en la legislación aplicable. Notificaremos cambios significativos a través de la Plataforma o por correo electrónico. La fecha de la última actualización se indica al inicio de esta política.</p>

<h4>14. Contacto del Delegado de Protección de Datos</h4>
<p>Para cualquier consulta relacionada con la protección de datos personales, contacta a nuestro equipo:</p>
<p><strong>Correo electrónico:</strong> contacto@domus-secura.cl<br>
<strong>Respuesta:</strong> en un plazo máximo de 48 horas hábiles.</p>`
